import { createSlice } from "@reduxjs/toolkit"


const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    users: null,
    filteredUsers: null,
    filter: {
      search: null,
      pagination: null,

    },
    filterUserCount: [
      10, 50, 100, 200, 300
    ],
    pagination: null,
    isAdmin: false,
    selectedUsers: [],
    deactivateSelectedUsers: false,
    deleteSelectedUsers: false,
    selectedpagination:0,
    orders:[]

  },
  reducers: {

    setOrders(state,action){
state.orders=action.payload
    },


    setUser(state, action) {
      state.user = action.payload
      if(action.payload && action.payload.orders!==undefined){
 state.orders=action.payload.orders
      }
     
    },

    setUsers(state, action) {
      state.users = action.payload
    }
    ,
    setFilteredItems(state, action) {
      state.filteredUsers = action.payload
    }

    ,
    setFilter(state, action) {

      if (Array.isArray(action.payload)) {
        action.payload.map(item => {
          state.filter[item.key] = item.value
        })
      }
      else {
        state.filter[action.payload.key] = action.payload.value
      }


    },

    resetUsers(state){

      state.users=null
      state.filteredUsers=null
      state.filter={
        search: null,
        pagination: null,
      }

    },

    setPagination(state, action) {
      state.pagination = action.payload
    },
    setIsAdmin(state, action) {
      state.isAdmin = action.payload
    },
    removeUser(state, action) {

      state.users = state.users.filter(user => user.id !== action.payload)
      if(state.filteredUsers){
        state.filteredUsers = state.filteredUsers.filter(user => user.id !== action.payload)
      }
      

    }
    ,
    updateUser(state, action) {

      action.payload.map(item => {
        state.user[item.key] = item.value
      })


    },

    updateUsers(state, action) {

      Object.keys(state.users).forEach(key => {
        let item = state.users[key]

        action.payload.ids.map(id => {

          if (item.id == id) {

            action.payload.changes.map(ch => {

              if (ch.value !== null) {
                state.users[key][ch.key] = ch.value

              }
            })
          }
        })

      })

      if(state.filteredUsers){

        Object.keys(state.filteredUsers).forEach(key => {
          let item = state.filteredUsers[key]
  
          action.payload.ids.map(id => {
  
            if (item.id == id) {
  
              action.payload.changes.map(ch => {
  
                if (ch.value !== null) {
                  state.filteredUsers[key][ch.key] = ch.value
  
                }
              })
            }
          })
  
        })


      }

    },

    addUser(state, action) {
      state.users = [...state.users, action.payload]
      state.filteredUsers = [...state.filteredUsers, action.payload]
    }
    ,
    onSelectUser(state, action) {
      if (action.payload.action === 'add') {
        state.selectedUsers = [...state.selectedUsers, action.payload.user]
      }
      if (action.payload.action === 'remove') {
        state.selectedUsers = state.selectedUsers.filter(user => user.id !== action.payload.user.id)
      }
    }

    ,
    onDeactivateSelectedUsers(state, action) {
      state.deactivateSelectedUsers = !state.deactivateSelectedUsers
    },
    onDeleteSelectedUsers(state, action) {
      
      state.deleteSelectedUsers = !state.deleteSelectedUsers
    },
    setSelectedPagination(state,action){
      state.selectedpagination=action.payload
    }

  },
});

export default userSlice

export const userActions = userSlice.actions;